<div class="status-container">
  <!-- Connection -->
  <div class="status-row">
    <div class="status-icon">
      <mat-icon *ngIf="ecommerceConnection.connectionStatus === 'INITIAL'" color="primary">question_mark</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.connectionStatus === 'SUCCESS'" color="primary">check_circle</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.connectionStatus === 'ERROR'" color="warn">error</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.connectionStatus === 'WARNING'" color="accent">warning</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.connectionStatus === null">remove</mat-icon>
    </div>
    <div class="status-label" i18n="@@Connection">Connection</div>
    <div class="status-timeago">
      <span *ngIf="ecommerceConnection.lastConnection">{{ getTimeAgo(ecommerceConnection.lastConnection) }}</span>
      <span *ngIf="!ecommerceConnection.lastConnection" i18n="@@No activity recorded">No activity recorded</span>
    </div>
    <div class="status-check">
      <button mat-raised-button (click)="checkConnection(ecommerceConnection)" [disabled]="lastConnectionUpdating">
        <mat-spinner *ngIf="lastConnectionUpdating" diameter="20"></mat-spinner>
        <span *ngIf="!lastConnectionUpdating" i18n="@@Check">Check</span>
      </button>
    </div>
  </div>

  <!-- Order Check.
       The status icon and the "how long ago" are suppressed when this
       connection does not poll for orders: there is no schedule behind
       them, so whatever they hold is either permanently INITIAL or a
       frozen result from whenever the setting was last on. The manual
       Check button stays - a one-off read is still a legitimate action
       on a connection that does not poll, and it is the only way to
       pull orders in on demand. -->
  <div class="status-row" [class.status-row-off]="!pollsForOrders">
    <div class="status-icon">
      <ng-container *ngIf="pollsForOrders">
        <mat-icon *ngIf="ecommerceConnection.orderCheckStatus === 'INITIAL'" color="primary">question_mark</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.orderCheckStatus === 'SUCCESS'" color="primary">check_circle</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.orderCheckStatus === 'ERROR'" color="warn">error</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.orderCheckStatus === 'WARNING'" color="accent">warning</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.orderCheckStatus === null">remove</mat-icon>
      </ng-container>
      <mat-icon *ngIf="!pollsForOrders" class="status-icon-off">do_not_disturb_on</mat-icon>
    </div>
    <div class="status-label" i18n="@@Orders Read">Orders Read</div>
    <div class="status-timeago">
      <ng-container *ngIf="pollsForOrders">
        <span *ngIf="ecommerceConnection.lastOrderCheck">{{ getTimeAgo(ecommerceConnection.lastOrderCheck) }}</span>
        <span *ngIf="!ecommerceConnection.lastOrderCheck" i18n="@@No activity recorded">No activity recorded</span>
      </ng-container>
      <span *ngIf="!pollsForOrders" class="status-off-note" i18n="@@This store is not set up to read orders on a schedule">This store is not set up to read orders on a schedule</span>
    </div>
    <div class="status-check">
      <button mat-raised-button (click)="readOrders(ecommerceConnection)" [disabled]="lastOrderCheckUpdating">
        <mat-spinner *ngIf="lastOrderCheckUpdating" diameter="20"></mat-spinner>
        <span *ngIf="!lastOrderCheckUpdating" i18n="@@Check">Check</span>
      </button>
    </div>
  </div>
  <div class="status-message-row" *ngIf="pollsForOrders && ecommerceConnection.orderCheckMessage">
    <div class="status-message">{{ecommerceConnection.orderCheckMessage}}</div>
  </div>

  <!-- Order Processed.
       Always applies: every order that reaches us is processed,
       whether it arrived by polling or by webhook. -->
  <div class="status-row">
    <div class="status-icon">
      <mat-icon *ngIf="ecommerceConnection.orderProcessedStatus === 'INITIAL'" color="primary">question_mark</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.orderProcessedStatus === 'SUCCESS'" color="primary">check_circle</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.orderProcessedStatus === 'ERROR'" color="warn">error</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.orderProcessedStatus === 'WARNING'" color="accent">warning</mat-icon>
      <mat-icon *ngIf="ecommerceConnection.orderProcessedStatus === null">remove</mat-icon>
    </div>
    <div class="status-label" i18n="@@Orders Processed">Orders Processed</div>
    <div class="status-timeago">
      <!-- Gated on lastOrderProcessed, which is also what it prints.
           It used to test lastProductRead and print lastOrderProcessed,
           so this row reported "No activity recorded" for a connection
           that had processed orders but never read products, and a
           time-ago for one that had read products but never processed
           an order. -->
      <span *ngIf="ecommerceConnection.lastOrderProcessed">{{ getTimeAgo(ecommerceConnection.lastOrderProcessed) }}</span>
      <span *ngIf="!ecommerceConnection.lastOrderProcessed" i18n="@@No activity recorded">No activity recorded</span>
    </div>
    <div class="status-check">
    </div>
  </div>

  <!-- Product Read -->
  <div class="status-row" [class.status-row-off]="!pollsForProducts">
    <div class="status-icon">
      <ng-container *ngIf="pollsForProducts">
        <mat-icon *ngIf="ecommerceConnection.productReadStatus === 'INITIAL'" color="primary">question_mark</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productReadStatus === 'SUCCESS'" color="primary">check_circle</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productReadStatus === 'ERROR'" color="warn">error</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productReadStatus === 'WARNING'" color="accent">warning</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productReadStatus === null">remove</mat-icon>
      </ng-container>
      <mat-icon *ngIf="!pollsForProducts" class="status-icon-off">do_not_disturb_on</mat-icon>
    </div>
    <div class="status-label" i18n="@@Products Read">Products Read</div>
    <div class="status-timeago">
      <ng-container *ngIf="pollsForProducts">
        <span *ngIf="ecommerceConnection.lastProductRead">{{ getTimeAgo(ecommerceConnection.lastProductRead) }}</span>
        <span *ngIf="!ecommerceConnection.lastProductRead" i18n="@@No activity recorded">No activity recorded</span>
      </ng-container>
      <span *ngIf="!pollsForProducts" class="status-off-note" i18n="@@This store is not set up to read products on a schedule">This store is not set up to read products on a schedule</span>
    </div>
    <div class="status-check">
      <button mat-raised-button (click)="readProducts(ecommerceConnection)" [disabled]="lastProductReadUpdating">
        <mat-spinner *ngIf="lastProductReadUpdating" diameter="20"></mat-spinner>
        <span *ngIf="!lastProductReadUpdating" i18n="@@Check">Check</span>
      </button>
    </div>
  </div>
  <div class="status-message-row" *ngIf="pollsForProducts && ecommerceConnection.productReadMessage">
    <div class="status-message">{{ecommerceConnection.productReadMessage}}</div>
  </div>

  <!-- Product Processed -->
  <div class="status-row" [class.status-row-off]="!processesProducts">
    <div class="status-icon">
      <ng-container *ngIf="processesProducts">
        <mat-icon *ngIf="ecommerceConnection.productProcessedStatus === 'INITIAL'" color="primary">question_mark</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productProcessedStatus === 'SUCCESS'" color="primary">check_circle</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productProcessedStatus === 'ERROR'" color="warn">error</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productProcessedStatus === 'WARNING'" color="accent">warning</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.productProcessedStatus === null">remove</mat-icon>
      </ng-container>
      <mat-icon *ngIf="!processesProducts" class="status-icon-off">do_not_disturb_on</mat-icon>
    </div>
    <div class="status-label" i18n="@@Products Processed">Products Processed</div>
    <div class="status-timeago">
      <ng-container *ngIf="processesProducts">
        <span *ngIf="ecommerceConnection.lastProductProcessed">{{ getTimeAgo(ecommerceConnection.lastProductProcessed) }}</span>
        <span *ngIf="!ecommerceConnection.lastProductProcessed" i18n="@@No activity recorded">No activity recorded</span>
      </ng-container>
      <span *ngIf="!processesProducts" class="status-off-note" i18n="@@Product content is not being sent to this store">Product content is not being sent to this store</span>
    </div>
    <div class="status-check">
    </div>
  </div>
  <div class="status-message-row" *ngIf="processesProducts && ecommerceConnection.productProcessedMessage">
    <div class="status-message">{{ecommerceConnection.productProcessedMessage}}</div>
  </div>

  <!-- Shipment Update -->
  <div class="status-row" [class.status-row-off]="!reportsShipments">
    <div class="status-icon">
      <ng-container *ngIf="reportsShipments">
        <mat-icon *ngIf="ecommerceConnection.shipmentUpdateStatus === 'INITIAL'" color="primary">question_mark</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.shipmentUpdateStatus === 'SUCCESS'" color="primary">check_circle</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.shipmentUpdateStatus === 'ERROR'" color="warn">error</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.shipmentUpdateStatus === 'WARNING'" color="accent">warning</mat-icon>
        <mat-icon *ngIf="ecommerceConnection.shipmentUpdateStatus === null">remove</mat-icon>
      </ng-container>
      <mat-icon *ngIf="!reportsShipments" class="status-icon-off">do_not_disturb_on</mat-icon>
    </div>
    <div class="status-label" i18n="@@Shipment Update">Shipment Update</div>
    <div class="status-timeago">
      <ng-container *ngIf="reportsShipments">
        <span *ngIf="ecommerceConnection.lastShipmentProcessed">{{ getTimeAgo(ecommerceConnection.lastShipmentProcessed) }}</span>
        <span *ngIf="!ecommerceConnection.lastShipmentProcessed" i18n="@@No activity recorded">No activity recorded</span>
      </ng-container>
      <span *ngIf="!reportsShipments" class="status-off-note" i18n="@@Tracking numbers and order status are not being reported to this store">Tracking numbers and order status are not being reported to this store</span>
    </div>
    <div class="status-check">
    </div>
  </div>
  <div class="status-message-row" *ngIf="reportsShipments && ecommerceConnection.shipmentUpdateMessage">
    <div class="status-message">{{ecommerceConnection.shipmentUpdateMessage}}</div>
  </div>
</div>

